import React from "react";
import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom"; // Import useNavigate for redirection
import AwardImage from "../../../../assets/RealEnglishImages/FounderImage.jpg";
import "./Awards.css";

const Awards = () => {
  const navigate = useNavigate(); // Hook for navigation

  // Function to handle button click and redirect to /ELT-ExcellenceAwards
  const handleELTAwardsClick = () => {
    navigate("/ELT-ExcellenceAwards"); // Replace with your actual route
  };

  return (
    <section className="HomePageAward-section">
      <div className="particle-background"></div>
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} className="text-center">
            <div className="HomePageAward-card">
              <img
                src={AwardImage}
                alt="ELT Excellence Award"
                className="img-fluid mb-4"
              />
              <h2 className="display-5 fw-bold text-black mb-3">
                ELT Excellence Award 2024
              </h2>
              <p className="lead text-black">
                Recognized for our outstanding facilities and innovative learning
                environment.
              </p>

              {/* Super Effect Button */}
              <button className="elt-awards-button" onClick={handleELTAwardsClick}>
                Discover Our Excellence
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Awards;